/**
 * AccountCodeSelect — Accounts S4: the Region and Sector pickers on New
 * account and on the account's Edit form. "Not set" ('' on the wire: create
 * omits it, PATCH sends "" to clear) is the default; the options are
 * pkg/contracts/codes.json's, in its order. An unknown stored code (an api
 * newer than this bundle) stays selectable as itself, so editing another
 * field never silently drops it.
 */
import { REGIONS, SECTORS, type AccountCode } from '../../../../lib/accountCodes'

export function AccountCodeSelect({ kind, value, onChange, className, autoFocus, disabled }: {
  kind: 'region' | 'sector'
  value: string
  onChange: (code: string) => void
  className?: string
  autoFocus?: boolean
  disabled?: boolean
}) {
  const list: readonly AccountCode[] = kind === 'region' ? REGIONS : SECTORS
  const known = value === '' || list.some(c => c.code === value)
  return (
    <select value={value} onChange={e => onChange(e.target.value)} className={className}
      aria-label={kind === 'region' ? 'Region' : 'Sector'} autoFocus={autoFocus} disabled={disabled}>
      <option value="">Not set</option>
      {!known && <option value={value}>{value}</option>}
      {list.map(c => <option key={c.code} value={c.code}>{c.label}</option>)}
    </select>
  )
}
